export default __webpack_public_path__ + "img/fleche_droite.ba0dd524.svg";